import { PayloadAction } from '@reduxjs/toolkit';
import { EditorState } from 'src/store/editor/types';

const setLayoutSchemaSetNameReducer = (state: EditorState, action: PayloadAction<string>) => {
  state.layoutSchemaSetName = action.payload;
};

export default setLayoutSchemaSetNameReducer;
